import React, {useState} from 'react'
import {Row, Col, Button} from "react-bootstrap";
import Icon from '../../component/Icon/Icon';
import {ModalMessage} from '../../component/Modal/ModalMessage';
import BizStepService from '../../services/BizStepService';
import Notify from '../../services/Notify';
import ModalMessageNew from "../../component/Modal/ModalMessageNew";

class BizStepGrid {

  constructor() {
    this.bizStepService = new BizStepService()
  }

  title = "Etapas"
  exportNewPage = true;
  showPdfButton = false;
  columns = [{
    Header: 'Nome', accessor: 'friendlyName', HeaderColumn: true,
  }, {
    Header: 'Descrição', accessor: 'description',
  }, {
    Header: "Código ERP", accessor: "erpCode"
  }, {
    Header: "Opções", sortable: false, filterable: false, export: false, Cell: row => {
      const [showModal, setShowModal] = useState(false)

      const deleteBizStepById = async (bizStepId) => {
        try {
          await this.bizStepService.deleteById(bizStepId)
          this.forceReload()
          Notify.success("Etapa deletada com sucesso!")
        } catch (error) {
          Notify.error("Houve um erro ao deletar a etapa, tente novamente em instantes", error)
        } finally {
          setShowModal(false)
        }
      }

      const handleShowModal = () => setShowModal(!showModal)
      return (<Row className="justify-content-around">
        <Col sm={6}>
          <Button title='Editar' bsStyle="success" href={"#/biz-steps/" + row.original.id + "/edit"}
                  block>
            <Icon icon='pencil'/>
          </Button>
        </Col>
        <Col sm={6}>
          <Button title='Excluir' bsStyle="danger" block onClick={handleShowModal}>
            <Icon icon='trash'/>
          </Button>
        </Col>
        <ModalMessageNew
          title={`Tem certeza que deseja deletar a etapa ${row.original.friendlyName} ?`}
          errorButtonAction={handleShowModal}
          handleShowModal={handleShowModal}
          successButtonAction={() => deleteBizStepById(row.original.id)}
          showModal={showModal}
        />
      </Row>)
    }
  }]

  endpoint = () => {
    return `ton/v1/biz-steps`;
  };

}

export default BizStepGrid;



// WEBPACK FOOTER //
// ./src/customGrid/entities/BizStepGrid.js